import Befehl1IconRaw from '../../assets/icons/befehle/app_ic_befehl_01.svg?react'
import Befehl2IconRaw from '../../assets/icons/befehle/app_ic_befehl_02.svg?react'
import Befehl3IconRaw from '../../assets/icons/befehle/app_ic_befehl_03.svg?react'
import Befehl4IconRaw from '../../assets/icons/befehle/app_ic_befehl_04.svg?react'
import Befehl5IconRaw from '../../assets/icons/befehle/app_ic_befehl_05.svg?react'
import Befehl6IconRaw from '../../assets/icons/befehle/app_ic_befehl_06.svg?react'
import Befehl7IconRaw from '../../assets/icons/befehle/app_ic_befehl_07.svg?react'
import Befehl8IconRaw from '../../assets/icons/befehle/app_ic_befehl_08.svg?react'
import Befehl9IconRaw from '../../assets/icons/befehle/app_ic_befehl_09.svg?react'
import Befehl21IconRaw from '../../assets/icons/befehle/app_ic_befehl_21.svg?react'
import Befehl22IconRaw from '../../assets/icons/befehle/app_ic_befehl_22.svg?react'
import Befehl23IconRaw from '../../assets/icons/befehle/app_ic_befehl_23.svg?react'
import Befehl24IconRaw from '../../assets/icons/befehle/app_ic_befehl_24.svg?react'
import Befehl25IconRaw from '../../assets/icons/befehle/app_ic_befehl_25.svg?react'
import Befehl26IconRaw from '../../assets/icons/befehle/app_ic_befehl_26.svg?react'
import Befehl27IconRaw from '../../assets/icons/befehle/app_ic_befehl_27.svg?react'
import Befehl28IconRaw from '../../assets/icons/befehle/app_ic_befehl_28.svg?react'
import Befehl29IconRaw from '../../assets/icons/befehle/app_ic_befehl_29.svg?react'
import Befehl30IconRaw from '../../assets/icons/befehle/app_ic_befehl_30.svg?react'
import Befehl31IconRaw from '../../assets/icons/befehle/app_ic_befehl_31.svg?react'
import Befehl32IconRaw from '../../assets/icons/befehle/app_ic_befehl_32.svg?react'
import Befehl33IconRaw from '../../assets/icons/befehle/app_ic_befehl_33.svg?react'
import Befehl34IconRaw from '../../assets/icons/befehle/app_ic_befehl_34.svg?react'
import Befehl95IconRaw from '../../assets/icons/befehle/app_ic_befehl_95.svg?react'

import { withDefaultIconProps } from '../withDefaultIconProps'

export const Befehl1Icon = withDefaultIconProps(Befehl1IconRaw, 64)
export const Befehl2Icon = withDefaultIconProps(Befehl2IconRaw, 64)
export const Befehl3Icon = withDefaultIconProps(Befehl3IconRaw, 64)
export const Befehl4Icon = withDefaultIconProps(Befehl4IconRaw, 64)
export const Befehl5Icon = withDefaultIconProps(Befehl5IconRaw, 64)
export const Befehl6Icon = withDefaultIconProps(Befehl6IconRaw, 64)
export const Befehl7Icon = withDefaultIconProps(Befehl7IconRaw, 64)
export const Befehl8Icon = withDefaultIconProps(Befehl8IconRaw, 64)
export const Befehl9Icon = withDefaultIconProps(Befehl9IconRaw, 64)
export const Befehl21Icon = withDefaultIconProps(Befehl21IconRaw, 64)
export const Befehl22Icon = withDefaultIconProps(Befehl22IconRaw, 64)
export const Befehl23Icon = withDefaultIconProps(Befehl23IconRaw, 64)
export const Befehl24Icon = withDefaultIconProps(Befehl24IconRaw, 64)
export const Befehl25Icon = withDefaultIconProps(Befehl25IconRaw, 64)
export const Befehl26Icon = withDefaultIconProps(Befehl26IconRaw, 64)
export const Befehl27Icon = withDefaultIconProps(Befehl27IconRaw, 64)
export const Befehl28Icon = withDefaultIconProps(Befehl28IconRaw, 64)
export const Befehl29Icon = withDefaultIconProps(Befehl29IconRaw, 64)
export const Befehl30Icon = withDefaultIconProps(Befehl30IconRaw, 64)
export const Befehl31Icon = withDefaultIconProps(Befehl31IconRaw, 64)
export const Befehl32Icon = withDefaultIconProps(Befehl32IconRaw, 64)
export const Befehl33Icon = withDefaultIconProps(Befehl33IconRaw, 64)
export const Befehl34Icon = withDefaultIconProps(Befehl34IconRaw, 64)
export const Befehl95Icon = withDefaultIconProps(Befehl95IconRaw, 64)
